module.exports = __webpack_public_path__ + "img/reporting-actif.7b40648e.svg";